<script>
  import { tick } from "svelte";
  import Header from "../Component/Header.svelte";
  import { Link } from "../../Components";
  import Select from "svelte-select";
  import { Sponsors } from "../Api/congress";
  import { operationStore, query } from "@urql/svelte";
  import Item from "./Sponsors/Item.svelte";
  import Person from "../../Components/Icons/Person.svelte";
  import Group from "../../Components/Icons/Group.svelte";
  import ScreenUsers from "../../Components/Icons/ScreenUsers.svelte";

  export let congressId;
  const widgetView = "sponsors";
  const location = window.location;
  const pathname = location.pathname;

  let sponsorData = {};

  let preselectedValue = location.hash.substring(1);

  let selectedValue = null;
  let inProgress = false;

  const congress = operationStore(Sponsors, { congressId, widgetView });

  query(congress);

  congress.subscribe(async (storeObj) => {
    inProgress = storeObj.fetching;
    if (!inProgress && storeObj.data) {
      sponsorData = storeObj.data.sponsordata;
      if (preselectedValue) {
        selectedValue = sponsorData.sponsors.find((item) => item.ausstellerId === preselectedValue);
        preselectedValue = false;
      }
    }
  });

  async function pushState() {
    await tick();
    history.pushState(null, null, selectedValue ? `#${selectedValue.ausstellerId}` : pathname);
  }

  function popstate() {
    const preselectedValue = location.hash.substring(1);
    selectedValue = preselectedValue ? sponsorData.sponsors.find((item) => item.ausstellerId === preselectedValue) : null;
  }
</script>

<svelte:window on:popstate={popstate} />

<Header {congressId} {...sponsorData} />

<div class="prose mt-8 max-w-none">
  <h2 class="mb-2">Unsere Sponsoren</h2>
  <p>
    Als maßgeschneiderte Informationsplattform für institutionelle Investoren wird der Institutional Money Kongress {sponsorData?.congressYear} natürlich auch das richtige Ambiente für Branchengespräche,
    Erfahrungsaustausch und Geschäftskontakte bieten. Aus diesem Grund sind als Fachbesucher nur institutionelle Investoren zugelassen. Sales-Mitarbeiter von Investmentgesellschaften, die nicht zu den
    Sponsoren zählen, haben keinen Zutritt.
  </p>
  {#if sponsorData?.loungenplanUrl}
    <p>
      So finden Sie zu den Sponsoren: <Link href={sponsorData.loungenplanUrl} target="_blank" rel="noreferrer" link>Loungeplan</Link>
    </p>
  {/if}
  {#if sponsorData?.sponsoreninfotext}
    <p>{sponsorData.sponsoreninfotext}</p>
  {/if}
</div>

{#if sponsorData?.sponsors && sponsorData?.sponsors.length}
  <label for="sponsors-search" class="mb-1 mt-8 block text-xl">Sponsorenssuche:</label>
  <Select itemId="ausstellerId" on:change={pushState} on:clear={pushState} label="firmenname_IMK_AV" items={sponsorData.sponsors} id="sponsors-search" bind:value={selectedValue} placeholder="Suche" />

  <div class="mb-2 mt-8">
    <h2 class="mb-3 text-xl only:hidden">Premium-Eintrag</h2>
    {#each sponsorData.sponsors as item}
      {#if item.isPremium}
        <Item {item} selectedValueAusstellerId={selectedValue?.ausstellerId} large={true} />
      {/if}
    {/each}
  </div>

  <div class="mt-4 grid grid-cols-1 gap-2 bg-theme-gray-50 pt-2 sm:grid-cols-2 md:grid-cols-3">
    {#each sponsorData.sponsors as item}
      {#if !item.isPremium}
        <Item {item} selectedValueAusstellerId={selectedValue?.ausstellerId} large={false} />
      {/if}
    {/each}
  </div>
{/if}
